angular.module("jv.Candidate.Tasks.Factory", ['jv'])
    .factory('jvTasksFactory',['candidates', function(candidates){
    
        return {
        saveTask : function(form,index,applicationId,firstName,lastName,jobTitle,callBack){
            form.entityEId = applicationId;
            form.entityName = encodeURIComponent(firstName +" "+ lastName +": " + jobTitle);
            form.entityType = 'Application';
            if(!!form.ownerEId && $.trim(form.ownerEId.EId) !== ""){
                form.ownerEId = form.ownerEId.EId;
            }
            candidates.addTask( form, function(response){
                callBack(response);
            });
        }
    };
}]);
